import React from "react";
import { Back, SmallMapContainer } from "../../globalComponents/globalStyle";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import GoogleMapReact from "google-map-react";
import {
  componentTransition,
  componentTransitionProp,
} from "../../animation/index";
import { Row, Col } from "antd";
import { SchoolDetailsCard } from "./style";
import { useQuery } from "@apollo/client";
import { USER_WITH_SAME_SCHOOL } from "../../app/apollo/index";
import { ClusterContainer } from "../Locate/Style";
const Details = () => {
  const location: any = useLocation();

  const { data, loading, error } = useQuery(USER_WITH_SAME_SCHOOL, {
    variables: {
      schoolName: location?.state?.school?.name,
      school_id: location?.state?.school?.id,
    },
  });
  console.log("the data is", data);
  console.log("the loading is", loading);
  console.log("the error is", error);

  console.log("the state is", location?.state?.school);
  const Marker: React.FC<any> = ({ children }) => (
    <div
      style={{
        padding: "1px",
        color: "white",
        background: "none",
        width: "fitContent",
      }}
    >
      {children}
    </div>
  );
  return (
    <motion.div
      variants={componentTransition}
      initial="initial"
      animate="in"
      exit="out"
      transition={componentTransitionProp}
    >
      <Back />
      <SmallMapContainer>
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_KEY as string }}
          defaultCenter={{
            lat: Number(location?.state?.school?.location?.lat),
            lng: Number(location?.state?.school?.location?.lng),
          }}
          defaultZoom={10}
          yesIWantToUseGoogleMapApiInternals
        >
          <Marker
            lat={Number(location?.state?.school?.location?.lat)}
            lng={Number(location?.state?.school?.location?.lng)}
          >
            <ClusterContainer>location</ClusterContainer>
          </Marker>
        </GoogleMapReact>
      </SmallMapContainer>
      <br />
      <Row justify="space-between">
        <Col xs={{ span: 24 }} lg={{ span: 11 }}>
          <SchoolDetailsCard>
            <h2>School Details</h2>
            <h3> Name: {location?.state?.school?.name}</h3>
            <h3> Country: {location?.state?.school?.country}</h3>
            <h3>
              Province:
              {location?.state?.school?.state_province === null
                ? " Currently Unvavailable"
                : location?.state?.school?.state_province}
            </h3>
            <h3>
              {" "}
              School Domain:{" "}
              <a
                rel="noreferrer "
                href={`https://${location?.state?.school?.domains[0]}`}
                target="_blank"
              >
                {location?.state?.school?.domains[0]}
              </a>{" "}
            </h3>
          </SchoolDetailsCard>
        </Col>
        <Col xs={{ span: 24 }} lg={{ span: 12 }}>
          <SchoolDetailsCard>
            <h2>Alumni / Student</h2>
            {loading && "Loading..."}
            {data?.getUsersWithSameSchool?.length === 0 &&
              "No Alumni/Student is currently available"}
          </SchoolDetailsCard>
        </Col>
      </Row>
    </motion.div>
  );
};

export default Details;
